import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography, Box } from '@mui/material';

import DisputesTable from './DisputesTable';

const DISPUTE_HELP_URL = 'https://www.invaluableauctions.com/inv/help-center/resource/disputes/';
const DisputesDetails = () => {
  const { catalogHeaders = [], groupedData = [] } = useSelector(
    state => state.reports.sessionLots
  );

  const showMultipleSessions = catalogHeaders.length > 1;

  return (
    <Grid>
      {groupedData.length ? (
        <Box>
          <Box className="dispute-header">
            {catalogHeaders?.map(header => (
              <Typography variant="body2" fontWeight="bold" key={header.catalogRef}>
                {showMultipleSessions
                  ? `Session ${header.prefix}: ${header.title} - ${header.date.split(' ')[0]}`
                  : `${header.title} - ${header.date.split(' ')[0]}`}
              </Typography>
            ))}
          </Box>
          <Box mt={2}>
            <Typography variant="body2" fontWeight="bold">
              Send an Unpaid Item Reminder / Mutual Resolution Notification
            </Typography>
            <Typography variant="body2" mt={1}>
              <a href={DISPUTE_HELP_URL} target="_blank">
                Learn more about managing disputes and returns »
              </a>
            </Typography>
          </Box>
          <Box mt={4}>
            <Typography variant="body2" fontWeight="bold">
              Selected Buyer(s) and Item(s)
            </Typography>
            <DisputesTable
              catalogs={groupedData}
              showMultipleSessions={showMultipleSessions}
            />
          </Box>
        </Box>
      ) : (
        <Typography variant="h6" color="red">
          No Result Found
        </Typography>
      )}
    </Grid>
  );
};

export default DisputesDetails;
